import { useReducer } from 'react'
import { GlobalContext } from './GlobalContext'

const win = window
const lang = win['lang']
const dir = lang === null || lang === 'en' ? 'ltr' : 'rtl'
const rtl = lang === 'ar'

const initialState = {
  rtl: rtl,
  dir: dir,
  lang: lang,
  pageToDisplay: 'TrackMyOrder',
  orderNumber: '',
  inquiryRes: '',
  phoneNumber: '',
  showDetails: '',
  changesSaved: '',
  transactionId: '',
  changedAddress: '',
  changedNotes: '',
  actionName: '',
  selectedOrderDetails: '',
  googleMapsLoaded: false,
  refId: '',
  journey: ''
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'TRACK_MY_ORDER_SUCCESS':
      return {
        ...state,
        orderNumber: action.payload.orderNumber,
        inquiryRes: action.payload.inquiryRes,
        phoneNumber: action.payload.phoneNumber,
      }

    case 'MAP_LOAD_SUCCESS':
      return {
        ...state,
        googleMapsLoaded: action.payload.googleMapsLoaded,
      }

    case 'DELIVERY_DETAILS_SUCCESS':
      return {
        ...state,
        changesSaved: action.payload.changesSaved,
        changedAddress: action.payload.changedAddress,
        changedNotes: action.payload.changedNotes,
      }

    case 'ORDER_DETAILS_SUCCESS':
      return {
        ...state,
        actionName: action.payload.actionName,
      }

    case 'LIST_OF_ORDERS_SUCCESS':
      return {
        ...state,
        selectedOrderDetails: action.payload.selectedOrderDetails,
      }

    case 'GO_TO_SCREEN':
      return {
        ...state,
        pageToDisplay: action.payload.page,
        journey: action.payload.journey,
      }

    case 'CANCEL_TRANSFER_REQUEST_SUCCESS':
      return {
        ...state,
        OrderId: action.payload.orderId,
      }

    case 'GO_TO_HOME_SCREEN':
      return {
        ...initialState,
        pageToDisplay: action.payload.page,
      }

      case 'OTP_SCREEN_SUCCESS':
      return {
        ...state,
        showDetails: action.payload.showDetails,
        refId: action.payload.refId,
      }

    default:
      return state
  }
}

export const GlobalProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return <GlobalContext.Provider value={[state, dispatch]}>{props.children}</GlobalContext.Provider>
}
